import { Component, Input, OnInit } from '@angular/core';
import { BlockAdderComponent } from '../BlockAdder/block-adder.component';
import { LayoutBlockTypesEnum } from '../../models/block.model';


@Component({
    selector: 'agpr-layout-block-adder',
    templateUrl: './layout-block-adder.component.html',
    styleUrls: ['./layout-block-adder.component.scss'],
    standalone: false
})
export class LayoutBlockAdderComponent extends BlockAdderComponent implements OnInit {

    @Input() isInline: boolean = false;
    @Input() disabled: boolean = false;

    readonly layoutBlockTypesEnumToFlexMap: Map<LayoutBlockTypesEnum, number[]> = new Map([
        [LayoutBlockTypesEnum.distributionOne, [1]],
        [LayoutBlockTypesEnum.briefingOne, [1]],
        [LayoutBlockTypesEnum.distributionTwo, [1, 1]],
        [LayoutBlockTypesEnum.briefingTwo, [1, 1]],
        [LayoutBlockTypesEnum.distributionThree, [1, 1, 1]],
        [LayoutBlockTypesEnum.briefingThree, [1, 1, 1]]
    ]);

    ngOnInit(): void {
        this.subscriptions.push(
            this.pageBuilderService.getLayoutBlockTypes().subscribe(
                (blockTypes) => {
                    this.blockTypes = blockTypes;
                }
            )
        );
    }

}
